import { React, useContext } from "react";
import {
  blobToFile,
  desiredDPI,
  saveFile,
  convertImageToMimeType,
} from "../Utils";
import { PageContext } from "../../App";
import NUpOutputOrientation from "../pdf_n_up_tool/NUpOutputOrientation";
import { htmlImageToPDF } from "../PDFHelper/PDFRenderer";

function HTMLToPdfOutputSettingsView() {
  //get context
  const {
    isConverting,
    imageDetails,
    exportFileDetails,
    setExportFileDetails,
  } = useContext(PageContext);

  //on  filename value changed
  const onFilenameValueChanged = (e) => {
    //set values
    setExportFileDetails({
      ...exportFileDetails,
      [e.target.id]: e.target.value,
    });
  };

  //on change dimension inputs
  const onChangeDimensionInputs = (e) => {
    //check
    if (exportFileDetails.width === 0 || exportFileDetails.height === 0) {
      //return
      return;
    }

    //ratio
    const ratio = exportFileDetails.width / exportFileDetails.height;
    //set
    //change w.r.t aspect ratio
    //if linked
    setExportFileDetails({
      ...exportFileDetails,
      width:
        e.target.id === "height"
          ? exportFileDetails.linked
            ? Math.floor(e.target.value * ratio)
            : exportFileDetails.width
          : e.target.value,
      height:
        e.target.id === "width"
          ? exportFileDetails.linked
            ? Math.floor(e.target.value * (1 / ratio))
            : exportFileDetails.height
          : e.target.value,
    });
  };

  return (
    <div
      className={`container mt-5 pb-3 ${isConverting === true || imageDetails.imageBlob === null ? "d-none" : ""}`}
    >
      {/* Content */}
      <div className="bg-light border-bottom">
        {" "}
        {/* Heading */}
        <label className="text-center lead w-100 fs-3 text-white fw-bold py-2 bg-info shadow">
          PDF Page Settings
        </label>
        {/*Image */}
        <div className="text-center mt-5">
          {/*Image */}
          <img
            className="border border-primary"
            alt="html_to_image"
            src={
              imageDetails.imageBlob !== null
                ? URL.createObjectURL(imageDetails.imageBlob)
                : null
            }
            style={{
              width: "100px",
              height: "auto",
              maxWidth: "100px",
              maxHeight: "auto",
            }}
          />
          {/* Size image */}
          <div className="text-center mt-3">
            <label>
              Page size:{" "}
              {Math.floor(imageDetails.imageDimension.width) +
                " x " +
                Math.floor(imageDetails.imageDimension.height)}
            </label>
          </div>
        </div>
        {/* Row 1*/}
        <div className="row px-5 py-4">
          {/* page setting */}
          <div className="col-lg-6 col-12 mt-5">
            {/* Title */}
            <label className="fs-4">Page Size:</label>
            {/* Page size */}
            <div className="d-flex my-auto mt-3">
              {/* Label */}
              <label className="fs-6 me-2 text-secondary">Page Layout:</label>
              {/* Dropdown menu */}
              <div className="dropdown">
                <label
                  className="dropdown-toggle fs-6 text-primary"
                  type="text"
                  id="dropdownMenu"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    //toggle
                    setExportFileDetails({
                      ...exportFileDetails,
                      exportPageLayoutPopupShowing:
                        exportFileDetails.exportPageLayoutPopupShowing === true
                          ? false
                          : true,
                      exportOrientationPopupShowing: false,
                    });
                  }}
                >
                  {exportFileDetails.pageLayout}
                </label>
                <div
                  className={`dropdown-menu ${
                    exportFileDetails.exportPageLayoutPopupShowing === true
                      ? "show"
                      : ""
                  }`}
                  aria-labelledby="dropdownMenu"
                >
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(8.3 * desiredDPI),
                                Math.floor(11.7 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(8.3 * desiredDPI),
                                Math.floor(11.7 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(8.3 * desiredDPI),
                                Math.floor(11.7 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(8.3 * desiredDPI),
                                Math.floor(11.7 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "A4",
                      });
                    }}
                  >
                    A4
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(11.7 * desiredDPI),
                                Math.floor(16.5 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(11.7 * desiredDPI),
                                Math.floor(16.5 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(11.7 * desiredDPI),
                                Math.floor(16.5 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(11.7 * desiredDPI),
                                Math.floor(16.5 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "A3",
                      });
                    }}
                  >
                    A3
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(5.8 * desiredDPI),
                                Math.floor(8.3 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(5.8 * desiredDPI),
                                Math.floor(8.3 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(5.8 * desiredDPI),
                                Math.floor(8.3 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(5.8 * desiredDPI),
                                Math.floor(8.3 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "A5",
                      });
                    }}
                  >
                    A5
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(4.1 * desiredDPI),
                                Math.floor(5.8 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(4.1 * desiredDPI),
                                Math.floor(5.8 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(4.1 * desiredDPI),
                                Math.floor(5.8 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(4.1 * desiredDPI),
                                Math.floor(5.8 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "A6",
                      });
                    }}
                  >
                    A6
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(6.9 * desiredDPI),
                                Math.floor(9.8 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(6.9 * desiredDPI),
                                Math.floor(9.8 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(6.9 * desiredDPI),
                                Math.floor(9.8 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(6.9 * desiredDPI),
                                Math.floor(9.8 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "B5",
                      });
                    }}
                  >
                    B5
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(7.25 * desiredDPI),
                                Math.floor(10.5 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(7.25 * desiredDPI),
                                Math.floor(10.5 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(7.25 * desiredDPI),
                                Math.floor(10.5 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(7.25 * desiredDPI),
                                Math.floor(10.5 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "Executive",
                      });
                    }}
                  >
                    Executive
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(11 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(11 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(11 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(11 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "US Letter",
                      });
                    }}
                  >
                    US Letter
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(14 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(14 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(14 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(8.5 * desiredDPI),
                                Math.floor(14 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "Legal",
                      });
                    }}
                  >
                    Legal
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(11 * desiredDPI),
                                Math.floor(17 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(11 * desiredDPI),
                                Math.floor(17 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(11 * desiredDPI),
                                Math.floor(17 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(11 * desiredDPI),
                                Math.floor(17 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: "Tabloid/Ledger",
                      });
                    }}
                  >
                    Tabloid/Ledger
                  </button>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(12 * desiredDPI),
                                Math.floor(18 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(12 * desiredDPI),
                                Math.floor(18 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(12 * desiredDPI),
                                Math.floor(18 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(12 * desiredDPI),
                                Math.floor(18 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: 'ARCH B (12" x 18")',
                      });
                    }}
                  >
                    ARCH B (12" x 18")
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(18 * desiredDPI),
                                Math.floor(24 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(18 * desiredDPI),
                                Math.floor(24 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(18 * desiredDPI),
                                Math.floor(24 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(18 * desiredDPI),
                                Math.floor(24 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: 'ARCH C (18" x 24")',
                      });
                    }}
                  >
                    ARCH C (18" x 24")
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(24 * desiredDPI),
                                Math.floor(24 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(24 * desiredDPI),
                                Math.floor(36 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(24 * desiredDPI),
                                Math.floor(36 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(24 * desiredDPI),
                                Math.floor(36 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: 'ARCH D (24" x 36")',
                      });
                    }}
                  >
                    ARCH D (24" x 36")
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(6 * desiredDPI),
                                Math.floor(9 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(6 * desiredDPI),
                                Math.floor(9 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(6 * desiredDPI),
                                Math.floor(9 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(6 * desiredDPI),
                                Math.floor(9 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: '6" x 9"',
                      });
                    }}
                  >
                    6" x 9"
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(5.5 * desiredDPI),
                                Math.floor(8.5 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(5.5 * desiredDPI),
                                Math.floor(8.5 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(5.5 * desiredDPI),
                                Math.floor(8.5 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(5.5 * desiredDPI),
                                Math.floor(8.5 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: '5.5" x 8.5"',
                      });
                    }}
                  >
                    5.5" x 8.5"
                  </button>{" "}
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={(e) => {
                      //set page size
                      setExportFileDetails({
                        ...exportFileDetails,
                        width:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.min(
                                Math.floor(12 * desiredDPI),
                                Math.floor(12 * desiredDPI),
                              )
                            : Math.max(
                                Math.floor(12 * desiredDPI),
                                Math.floor(12 * desiredDPI),
                              ),
                        height:
                          exportFileDetails.output_orientation ===
                          NUpOutputOrientation.PORTRAIT
                            ? Math.max(
                                Math.floor(12 * desiredDPI),
                                Math.floor(12 * desiredDPI),
                              )
                            : Math.min(
                                Math.floor(12 * desiredDPI),
                                Math.floor(12 * desiredDPI),
                              ),
                        exportPageLayoutPopupShowing: false,
                        exportOrientationPopupShowing: false,
                        pageLayout: '12" x 12"',
                      });
                    }}
                  >
                    12" x 12"
                  </button>
                </div>
              </div>
            </div>
            {/* Page Dimension */}
            {/* Label output dimension */}
            <div className="d-flex align-items-center mt-3">
              {/* Width */}
              <div className="d-flex">
                {/* label */}
                <label className="me-2 my-auto text-secondary">Width:</label>
                <input
                  className="form-control"
                  id="width"
                  placeholder="width"
                  value={exportFileDetails.width}
                  type="number"
                  style={{ width: "80px", maxWidth: "80px" }}
                  onChange={onChangeDimensionInputs}
                ></input>
              </div>

              {/* Lock Aspect Ratio */}
              <img
                loading="lazy"
                className="opacity-50 me-3 ms-3"
                src={
                  exportFileDetails.linked
                    ? "./images/lock-fill.svg"
                    : "./images/unlock-fill.svg"
                }
                alt="link"
                style={{
                  width: "24px",
                  height: "auto",
                  maxWidth: "24px",
                  maxHeight: "24px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  //toggle
                  setExportFileDetails({
                    ...exportFileDetails,
                    linked: exportFileDetails.linked ? false : true,
                  });
                }}
              />

              {/* Height */}
              <div className="d-flex">
                {/* label */}
                <label className="me-2 my-auto text-secondary">Height:</label>
                <input
                  className="form-control"
                  id="height"
                  placeholder="height"
                  value={exportFileDetails.height}
                  type="number"
                  style={{ width: "80px", maxWidth: "80px" }}
                  onChange={onChangeDimensionInputs}
                ></input>
              </div>
            </div>
            {/* Orientation */}
            {/* Output Orientation */}
            <div className="mt-5">
              {/* Title */}
              <label className="fs-4">Page Orientation:</label>
              <div className="d-flex my-auto mt-3">
                {/* Label */}
                <label className="fs-6 me-2 text-secondary">Orientation:</label>
                {/* Dropdown menu */}
                <div className="dropdown">
                  <label
                    className="dropdown-toggle fs-6 text-primary"
                    type="text"
                    id="dropdownMenu"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      //show hide color picker
                      //turn other popups off
                      setExportFileDetails({
                        ...exportFileDetails,
                        exportOrientationPopupShowing:
                          exportFileDetails.exportOrientationPopupShowing
                            ? false
                            : true,
                        exportPageLayoutPopupShowing: false,
                      });
                    }}
                  >
                    {String(exportFileDetails.output_orientation)}
                  </label>
                  <div
                    className={`dropdown-menu ${
                      exportFileDetails.exportOrientationPopupShowing === true
                        ? "show"
                        : ""
                    }`}
                    aria-labelledby="dropdownMenu"
                  >
                    {Object.values(NUpOutputOrientation).map((item, index) => (
                      <button
                        key={index}
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //show hide color picker
                          //turn other popups off
                          setExportFileDetails({
                            ...exportFileDetails,
                            width:
                              item === NUpOutputOrientation.PORTRAIT
                                ? Math.min(
                                    exportFileDetails.width,
                                    exportFileDetails.height,
                                  )
                                : Math.max(
                                    exportFileDetails.width,
                                    exportFileDetails.height,
                                  ),
                            height:
                              item === NUpOutputOrientation.PORTRAIT
                                ? Math.max(
                                    exportFileDetails.width,
                                    exportFileDetails.height,
                                  )
                                : Math.min(
                                    exportFileDetails.width,
                                    exportFileDetails.height,
                                  ),
                            output_orientation: item,
                            exportOrientationPopupShowing: false,
                            exportPageLayoutPopupShowing: false,
                          });
                        }}
                      >
                        {String(item)}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right column */}
          <div className="col-lg-6 col-12 mt-5">
            {/* password */}
            <div>
              {/* Title */}
              <label className="fs-4">Document Password:</label>
              {/* Output password */}
              <div className="d-flex my-auto mt-3">
                {/* Label password input */}
                <div>
                  <label
                    htmlFor="password"
                    className="fs-6 text-secondary"
                    title="PDF password"
                  >
                    PDF Password:
                  </label>
                  <input
                    type="password"
                    className="ms-3 rounded-2 border border-clear"
                    id="password"
                    aria-describedby="password"
                    placeholder="PDF password"
                    onChange={onFilenameValueChanged}
                    style={{ width: "150px" }}
                  />
                </div>
              </div>
            </div>

            {/* Output filename */}
            <div className="mt-5">
              {/* Title */}
              <label className="fs-4">Filename:</label>
              {/* Output Filename */}
              <div className="d-flex my-auto mt-3">
                {/* Label filename input */}
                <div>
                  <label
                    htmlFor="filename"
                    className="fs-6 text-secondary"
                    title="Output filename"
                  >
                    Output filename:
                  </label>
                  <input
                    type="text"
                    className="ms-3 rounded-2 border border-clear"
                    id="filename"
                    aria-describedby="filename"
                    placeholder="Output filename (xyz)"
                    onChange={onFilenameValueChanged}
                    style={{ width: "150px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* generate button */}
        <div className="text-center mb-4">
          <button
            className={`btn btn-primary px-4 py-2 mt-3 fs-5 `}
            style={{ width: "200px", height: "60px" }}
            onClick={async (e) => {
              //converted blob to png
              const imgBlob = await convertImageToMimeType(
                await blobToFile(imageDetails.imageBlob, "tmp"),
                "image/png",
                1.0,
              );
              //convert html image to pdf
              htmlImageToPDF(
                "HTMLToPDF",
                await blobToFile(imgBlob, exportFileDetails.filename), //image file as png
                {
                  password: exportFileDetails.password,
                  filename: exportFileDetails.filename,
                  width: exportFileDetails.width,
                  height: exportFileDetails.height,
                },
                (blob) => {
                  //save blob
                  saveFile(blob, exportFileDetails.filename + ".pdf");
                },
              );
            }}
          >
            Download PDF
          </button>
        </div>
      </div>
    </div>
  );
}

export default HTMLToPdfOutputSettingsView;
